import { SignUp } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CLERK_APPEARANCE } from './clerk_appearance';

export default function SignUpPage() {
  const { t } = useTranslation();

  return (
    <div className="max-w-md mx-auto px-8 py-24 text-center">
      <h1 className="font-serif text-4xl font-medium mb-3">{t('auth.title')}</h1>
      <p className="text-base text-ink-2 mb-10">{t('auth.subClerk')}</p>

      <div className="flex justify-center">
        <SignUp
          routing="virtual"
          signInUrl="/auth"
          fallbackRedirectUrl="/auth/callback"
          appearance={CLERK_APPEARANCE}
        />
      </div>

      <p className="text-[13px] text-ink-3 mt-6">
        {t('auth.agreement')}{' '}
        <Link to="/legal/terms" className="text-ink border-b border-current pb-px">
          {t('auth.tos')}
        </Link>
        {' & '}
        <Link to="/legal/privacy" className="text-ink border-b border-current pb-px">
          {t('auth.privacy')}
        </Link>
      </p>
    </div>
  );
}
